import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { ApiCallService } from "src/app/api/service/api-call.service";
import { ValidationService } from "src/app/services/validation.service";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-ssp-login",
  templateUrl: "./ssp-login.component.html",
  styleUrls: ["./ssp-login.component.css"],
})
export class SspLoginComponent implements OnInit {
  formErrors: { [key: string]: string } = {
    username: "",
    password: "",
  };
  logErrors() {
    this.validationService.logValidationErrors(
      this.sspForm,
      this.formErrors,
      this.validationMessages
    );
  }
  loading: boolean = false;
  sspForm!: FormGroup;
  pageHeading: any;
  token: string | null = "";
  validationMessages: { [key: string]: { [key: string]: string } } = {
    username: { required: "Username is required" },
    password: { required: "Password is required" },
  };
  constructor(
    private fb: FormBuilder,
    private validationService: ValidationService,
    private apiSvc: ApiCallService,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private title: Title
  ) {}

  ngOnInit(): void {
    this.title.setTitle('Life Insurance (SSP)');
    this.token = this.route.snapshot.queryParamMap.get("token");
    if (!this.token) {
      this.router.navigateByUrl("/");
      return;
    }
    this.sspForm = this.fb.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
    });
  }
  submitForm() {
   this.loading = true;

    let { username, password } = this.sspForm.getRawValue();
    
    username = btoa(username);
    password = btoa(password);

    const data = {
      body: { username, password },
      token: this.token as string,
    };

    console.log("data::::", data);
    this.apiSvc.sspLogin(data).subscribe({
      next: (res) => {
        window.location.href = environment.whatsappRedirectURL_UG;
       this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error(err.error.message, "Error");
        this.loading = false;
      },
    });
  }
}
